// import { createSlice } from "@reduxjs/toolkit";



// const initialState = {
//     organizationId:null,
// };


// const organization = createSlice({
//     name:'organization',
//     initialState,
//     reducers:{
//         setOrganizationId: (state,action) => {
//             return {
//                 ...state,
//                 organizationId:action.payload
//             }
//         }
//     }
// })

// export const {setOrganizationId} = organization.actions;

// export default organization.reducer;
// ...existing code...
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organizationId: process.env.REACT_APP_ORG_ID
    ? String(process.env.REACT_APP_ORG_ID)
    : null,

  // language is initialized ONLY here
  language: sessionStorage.getItem("language") || "en",
};

const organization = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizationId: (state, action) => {
      state.organizationId = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setOrganizationId, setLanguage } = organization.actions;
export default organization.reducer;
